// extracted by mini-css-extract-plugin
export default {"table_wrapper":"Kalender_table_wrapper__VnXCO","popup_wrapper":"Kalender_popup_wrapper__eWBoA"};